import { render, staticRenderFns } from "./SalesmanSetting.vue?vue&type=template&id=1429f9dd&scoped=true&"
import script from "./SalesmanSetting.vue?vue&type=script&lang=js&"
export * from "./SalesmanSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1429f9dd",
  null
  
)

export default component.exports